// extracted by mini-css-extract-plugin
module.exports = {"container":"BuyInsurance_container__2nU7n"};